import { api } from 'services/api';
import { Order } from 'types';

export const storeOrdersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getOrders: build.query<Order[], string>({
      query: (userId) => ({
        url: `${userId}/store-orders`,
        method: 'GET'
      })
    })
  })
});
